import * as types from '../types/delegations'
import createReducer from '../createReducer'

const initDelegationsState = {}

export default createReducer(initDelegationsState, {
  [types.UPDATE_EXISTING_DELEGATION](state, action) {
    const newDelegations = state
    newDelegations[action.delegation._id] = action.delegation
    return Object.assign({}, state, newDelegations)
  },
  [types.SET_ALL_DELEGATIONS](state, action) {
    return Object.assign({}, action.delegations)
  },
  [types.ADD_NEW_DELEGATION](state, action) {
    return Object.assign({}, state, { [action.delegation._id]: action.delegation })
  },
  [types.DELETE_DELEGATION](state, action) {
    const newState = state
    delete newState[action.delegation._id]
    return newState
  },
})
